import axios from 'axios';

import AccessControlDTO from '../types/AccessControlDTO';
import IAccessControlSettings from '../types/IAccessControlSettings';
import WorkspaceRoleDTO from '../types/WorkspaceRoleDTO';

export const getAccessControlSettings = (workspaceId: string) =>
  axios.get(`api/access-control/${workspaceId}`);

export const updateAccessControlSettings = (payload: AccessControlDTO) =>
  axios.put('api/access-control', payload);

export const getAllDefaultAccessSettings = (url: string, module: string) =>
  axios.get(`${url}/api/access/default?module=${module}`);

export const fetchWorkspaceAccessSettings = (url: string, module: string) =>
  axios.get(`${url}/api/access/fetch?module=${module}`);

export const saveAccessControlSettings = (
  url: string,
  module: string,
  payload: IAccessControlSettings[]
) => axios.post(`${url}/api/access/save?module=${module}`, payload);

export const addRoleForWorkspace = (payload: WorkspaceRoleDTO) =>
  axios.post('api/roles/add', payload);

export const fetchWorkspaceRole = () => axios.get('/api/roles/fetch');
